var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"min-width":"320px"}},[_c('v-card-text',[_vm._v("\n    Under Construction\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }